import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import MainContainer from "../../components/MainContainer";

import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";

import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

import General from "../../components/profile/General";
import Design from "../../components/profile/Design";
import Privacy from "../../components/profile/Privacy";

import "../stepper.css";
import Paper from "@material-ui/core/Paper";
import Hidden from "@material-ui/core/Hidden";
import Heading from "../../components/Heading";
import { ProfileType } from "../../types/enum";
import Signature from "../../components/profile/Signature";

const styles = theme => ({
    root: {
        width: "90%"
    },
    backButton: {
        marginRight: theme.spacing.unit
    },
    instructions: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit
    }
});


@inject("templateStore", "profileStore")
@observer
class EditStaff extends Component {
    componentDidMount = () => {
        // default to signature tab for development
        this.props.templateStore.setEditProfileActiveStep(0);
    };

    handleNext = () => {
        const { editProfileActiveStep } = this.props.templateStore;
        this.props.templateStore.setEditProfileActiveStep(editProfileActiveStep + 1);
    };

    handleBack = () => {
        const { editProfileActiveStep } = this.props.templateStore;
        this.props.templateStore.setEditProfileActiveStep(editProfileActiveStep - 1);
    };

    handleReset = () => {
        this.props.templateStore.setEditProfileActiveStep(0);
    };

    handleStepClick = step => () => {
        this.props.templateStore.setEditProfileActiveStep(step);
    };

    getStepContent(stepIndex) {
        const { profile } = this.props.profileStore;
        const isNewProfile = this.props.match?.params?.new === "new";
        const generalProfileId = isNewProfile ? undefined : profile?.id;
        const otherTabsProfileId = profile?.id;
        switch (stepIndex) {
            case 0:
                return <General type="staff" profileId={generalProfileId} />;
            case 1:
                return <Design type="staff" profileId={otherTabsProfileId} />;
            case 2:
                return <Signature type="staff" profileId={otherTabsProfileId} />;
            case 3:
                return <Privacy type="staff" profileId={otherTabsProfileId} />;
            default:
                return "Uknown stepIndex";
        }
    }

    render() {
        const { classes, match } = this.props;
        const steps = this.props.templateStore.getSteps("staff");
        const { editProfileActiveStep } = this.props.templateStore;
        const { profile } = this.props.profileStore;

        return (
            <div>
                <Header />
                <Sidebar />
                <MainContainer>
                    <Heading
                        title={
                            profile && profile.isCompleted && profile.type === ProfileType.Staff.ordinal
                                ? "Edit Venue Staff Profile"
                                : profile && match && match.params && !match.params.new
                                    ? "Edit Venue Staff Profile"
                                    : "Create Venue Staff Profile"
                        }
                    />
                    <Hidden smDown>
                        <Stepper nonLinear={profile && profile.isCompleted} activeStep={editProfileActiveStep} alternativeLabel={false}>
                            {steps.map((label, index) => {
                                return (
                                    <Step key={label}>
                                        <StepButton onClick={this.handleStepClick(index)}> {label} </StepButton>
                                    </Step>
                                );
                            })}
                        </Stepper>
                    </Hidden>
                    <Hidden mdUp xsDown>
                        <Stepper nonLinear={profile && profile.isCompleted} activeStep={editProfileActiveStep} alternativeLabel={true}>
                            {steps.map((label, index) => {
                                return (
                                    <Step key={label}>
                                        <StepButton onClick={this.handleStepClick(index)}> {label} </StepButton>
                                    </Step>
                                );
                            })}
                        </Stepper>
                    </Hidden>
                    <Hidden smUp>
                        <Stepper
                            nonLinear={profile && profile.isCompleted}
                            activeStep={editProfileActiveStep}
                            alternativeLabel={false}
                            className="stepperXs"
                        >
                            {steps.map((label, index) => {
                                return (
                                    <Step key={label}>
                                        <StepButton onClick={this.handleStepClick(index)} />
                                    </Step>
                                );
                            })}
                        </Stepper>
                    </Hidden>
                    {editProfileActiveStep === steps.length ? (
                        <Paper className="stepperContent">
                            <Typography className={classes.instructions} component="h3">
                                All steps completed - you 're profile is ready!
                            </Typography>
                            <Button onClick={this.handleReset}> Reset </Button>
                        </Paper>
                    ) : (
                        <Paper className="stepperContent"> {this.getStepContent(editProfileActiveStep)} </Paper>
                    )}
                </MainContainer>
            </div>
        );
    }
}

EditStaff.propTypes = {
    classes: PropTypes.object
};
export default withStyles(styles)(EditStaff);
